import _ from "lodash";
import {app} from "../../modules/config.ts";
import {Link} from "react-router-dom";
import type {DaoCategory} from "../../daos/dao-category.ts";

interface CategoryProps {
  classname?: string,
  current?: DaoCategory | null,
  callback?: () => void
}

function Category({classname, current, callback}: CategoryProps) {
  return (
    <div className={`category-list ${classname}`}>
      {
        app.categories.map((category: DaoCategory, idx: number) => (
          <div className="category-item" key={idx}><Link to={`/main/channel?category=${category.no}`}
                                                         onClick={() => callback?.()}
                                                         className={_.isEqual(current?.no, category.no) ? 'on' : ''}>{category.name}</Link>
          </div>
        ))
      }
    </div>
  );
}

export default Category;
